module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<fieldset class="cw-fieldset phx-populations-detail-structure-simple">\r\n    <div class="">\r\n        <div id="selectorEstructura"></div>\r\n        <br><br>\r\n        <div class="form-group">\r\n            ';
 if(context && context.ctxStructureSelpop){
__p+='\r\n                <div class="custom-control custom-checkbox phx-chemin-population-descendence '+
((__t=((context.ctxSelRemDesc == 0 || context.ctxSelRemDesc == 1 )?'d-none':''))==null?'':__t)+
'" >                    \r\n                <input id="cw-populationDescendence" class="populationDescendence custom-control-input" type="checkbox" '+
((__t=((context.ctxSelRemDesc == 0 || context.ctxSelRemDesc == 2 )?'checked':''))==null?'':__t)+
' '+
((__t=((context.ctxSelRemDesc == 2 || context.ctxSelRemDesc == 3 )?'':'disabled'))==null?'':__t)+
' value="true">\r\n                <label for="cw-populationDescendence" class="custom-control-label"> '+
((__t=( i18n.t("populationsmenu.returnerEgalement")))==null?'':__t)+
'</label>\r\n                </div>\r\n            ';
}
__p+='\r\n        </div>\r\n        <div class="">\r\n            <button type="button" class="buttonAppliquer btn btn-primary" style="float:left; margin-left:12px;">'+
((__t=(i18n.t("populationsmenu.appliquer")))==null?'':__t)+
'</button>\r\n        </div>\r\n    </div>\r\n</fieldset>\r\n';
}
return __p;
};
